import React from 'react'
import underConstruction from '../images/PageUnderConstruction.png'

const OurService = () => {
  return (
    <section>
      <div className='container text-center'>
        <img src={underConstruction} className='undrcnstrctn' />
      </div>
    </section>
  )
}

export default OurService
